import { useMaterialStore } from '@/stores/material'
import type {
  ActivityDto,
  MaterialImpactCalculationDto,
  MaterialPhaseValuesDto
} from '@/stores/buildingBlock'

/**
 * Keep material impacts fresh without refetching both material and block totals.
 */
export function useMaterialImpact() {
  const materialStore = useMaterialStore()

  const patchImpact = (
    materialId?: number | null,
    impact?: MaterialImpactCalculationDto,
    phaseValues?: MaterialPhaseValuesDto
  ) => {
    if (materialId == null || !impact) return
    const index = materialStore.items.findIndex((material) => material.id === materialId)
    if (index === -1) return
    materialStore.items[index] = {
      ...materialStore.items[index],
      ...(phaseValues ?? {}),
      impact_calculation: impact
    }
  }

  const applyActivityImpact = (response: ActivityDto | boolean | null | undefined) => {
    if (!response || typeof response !== 'object') return
    patchImpact(
      response.material,
      response.material_impact_calculation,
      response.material_phase_values
    )
  }

  const refreshMaterialImpact = async (materialId?: number | null) => {
    if (materialId == null) return
    const material = await materialStore.fetchItem(materialId)
    if (material && typeof material === 'object') {
      patchImpact(materialId, material.impact_calculation, material)
    }
  }

  return { applyActivityImpact, refreshMaterialImpact }
}
